import { useActor } from '../hooks/useActor';

export const withActor = (Component) => {
  const Wrapper = (props) => {
    const actor = useActor();

    return <Component actor={actor} {...props} />;
  };

  Wrapper.displayName = `withActor${Component.displayName || Component.name}`;

  return Wrapper;
};
